import { useNavigate, useParams } from 'react-router'

import { CoverImage } from 'js/components/CoverImage'
import { Container } from 'js/components/Grid'
import { H1 } from 'js/components/Heading'
import ItemActions from 'js/components/Item/ItemActions/ItemActions'
import Author from 'js/components/Item/ItemHeader/components/Author'
import ItemStatusTag from 'js/components/Item/ItemStatusTag'
import Section from 'js/components/Section/Section'
import TiptapView from 'js/components/Tiptap/TiptapView'

import type { MagazineArticleViewFragment } from '../../../fragments/MagazineArticleView.fragment.generated'
import type { MagazineIssueViewFragment } from '../../../fragments/MagazineIssueView.fragment.generated'

import styles from './ArticlePage.module.css'

type ArticlePageProps = {
    container: MagazineIssueViewFragment['container']
    article: MagazineArticleViewFragment
}

const ArticlePage = ({ container, article }: ArticlePageProps) => {
    const params = useParams()
    const navigate = useNavigate()

    const { guid, title, richDescription, featured } = article

    const onEdit = `/magazine-issue/edit/${params.containerGuid}/${guid}`

    const afterDelete = () => {
        navigate(container.url, {
            replace: true,
        })
    }

    return (
        <Section className={styles.wrapper}>
            <Container size="huge">
                <H1 className={styles.title}>
                    {title}
                    <ItemActions
                        // FIXME: laten we in frontend stoppen met alles entity te noemen
                        entity={article}
                        onEdit={onEdit}
                        onAfterDelete={afterDelete}
                        hideArchive={true}
                        className={styles.actions}
                        refetchQueries={['MagazineIssue', 'MagazineView']}
                    />
                    <ItemStatusTag
                        entity={article}
                        style={{
                            marginTop: '8px',
                        }}
                    />
                </H1>

                <Author entity={article} className={styles.author} />

                <CoverImage
                    featured={featured as any}
                    size="full"
                    borderRadius="16px"
                    className={styles.coverImage}
                />
            </Container>

            <Container size="normal">
                <TiptapView
                    content={richDescription}
                    textSize="large"
                    className={styles.content}
                />
            </Container>
        </Section>
    )
}

export default ArticlePage
